import React, {Component} from 'react';
import {Link} from 'react-router';

import SNIntro from './components/sn_intro';
import Perks from './components/perks';
import Footer from 'js/components/footer';

export default class DataEngineer extends Component {
    render() {
        return (
            <div id="job-page">
                <header className="header-blue">
                    <div id="sn-logo" className="hide show@sm">
                        <Link to="/">

                        </Link>
                    </div>
                    <div id="sn-logo-mobile" className="hide@sm">
                        <Link to="/">

                        </Link>
                    </div>
                    <div className="header-title">
                        <h2>Senior Data Engineer</h2>
                        <Link to="/jobs">Back To Jobs</Link>
                    </div>
                </header>
                <section id="policy">
                    <div className="terms-body">
                        <SNIntro />

                        <p className="p2">
                            {`We are hiring a `}<b>Senior Data Engineer</b> {`to further the company's data platform and related infrastructure. To perform this role, one needs experience with relational databases, NoSQL databases, and distributed computing. A data engineer is comfortable creating systems that ingest and analyze data at scale.`}
                        </p>
                        <p className="p1"><span className="s1"><b>Responsibilities</b></span></p>
                        <ul className="l1">
                            <li className="p3">{`Increase the quantity and expressiveness of the platform's data`}.</li>
                            <li className="p3">Analyze large amounts of social and crawl data.</li>
                            <li className="p3">Manage the infrastructure that collects, stores, and processes data.</li>
                            <li className="p3">Create predictive models and classifiers.</li>
                            <li className="p3">Tackle the core problem of "matching creators with brands".</li>
                        </ul>
                        <p className="p1"><span className="s1"><b>Traits of an Ideal Candidate</b></span></p>
                        <ul className="l1">
                            <li className="p3">{`Problem solver: enjoys a challenge and working on problems that don't have simple solutions.`}
                            </li>
                            <li className="p3">Data-oriented: strives to create data that is rich, structured, and
                                clean.
                            </li>
                            <li className="p3">Analytical: makes decisions based on experimentation, observation, and
                                data.
                            </li>
                            <li className="p3">Resourceful: finds creative ways to source and extract meaning from
                                unstructured data.
                            </li>
                        </ul>
                        <p className="p1"><span className="s1"><b>Skills & Qualifications</b></span></p>
                        <ul className="l1">
                            <li className="p3">4+ years programming experience in Python/Java.</li>
                            <li className="p3">Track record of delivering quality software.</li>
                            <li className="p3">Autonomouse and self-managed.</li>
                            <li className="p3">Excellent communication skills.</li>
                            <li className="p3">BS/MS in Computer Science, Computer Engineering or related technical discipline.</li>
                            <li className="p3">Strong mathematics background is a plus.</li>
                            <li className="p3">Startup experience is a plus.</li>
                        </ul>
                        <p className="p1"><span className="s1"><b>Relevant Technology</b></span></p>
                        <ul className="l1">
                            <li className="p3">Languages</li>
                            <ul className="l2">
                                <li className="p3">Java 8</li>
                                <li className="p3">Python</li>
                                <li className="p3">Javascript</li>
                            </ul>
                            <li className="p3">Databases</li>
                            <ul className="l2">
                                <li className="p3">MySQL/Postgres</li>
                                <li className="p3">Elasticsearch</li>
                                <li className="p3">Redis</li>
                            </ul>
                            <li className="p3">Concepts</li>
                            <ul className="l2">
                                <li className="p3">Web crawling</li>
                                <li className="p3">ETL pipelines</li>
                                <li className="p3">NLP/ML</li>
                                <li className="p3">Times series analytics</li>
                                <li className="p3">Map Reduce</li>
                            </ul>
                            <li className="p3">Infrastructure (Amazon Web Services)</li>
                            <ul className="l2">
                                <li className="p3">RDS</li>
                                <li className="p3">EC2 + Docker</li>
                            </ul>
                        </ul>
                        <p className="p1"><span className="s1"><b>Engineering Culture at SN</b></span></p>
                        <ul className="l1">
                            <li className="p3">Follow best practices.</li>
                            <li className="p3">Use the best tool for the job.</li>
                            <li className="p3">Write quality code.</li>
                            <li className="p3">Own and contribute to the product.</li>
                            <li className="p3">Be humble and repsect the ideas of others.</li>
                        </ul>
                        
                        <Perks />

                        <div className="link">
                            <a href="mailto:info@socialnative.com">
                                Interested? Shoot us a note telling us why.
                            </a>
                        </div>
                    </div>
                </section>
                <Footer dontShowJobs={true}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/pages/jobs_pages/data_engineer.js